import { Typography } from '@mui/material';
import React from 'react';

interface SectionHeaderProps {
  children: React.ReactNode;
}

function SectionHeader({ children }: SectionHeaderProps) {
  return (
    <Typography variant="h5" fontWeight="bold">
      {children}
    </Typography>
  );
}

export default SectionHeader;
